import * as schemas from './schemas';

export const onCreateSession = /* GraphQL */ `
  subscription OnCreateSession($filter:ModelSubscriptionSessionFilterInput) {
    onCreateSession(filter: $filter) {
      ${schemas.sessionSchema}
    }
  }
`;
export const onUpdateSession = /* GraphQL */ `
  subscription OnUpdateSession($filter:ModelSubscriptionSessionFilterInput){
    onUpdateSession(filter: $filter) {
      ${schemas.sessionSchema}
    }
  }
`;
export const onDeleteSession = /* GraphQL */ `
  subscription OnDeleteSession($filter:ModelSubscriptionSessionFilterInput) {
    onDeleteSession(filter: $filter) {
      ${schemas.sessionSchema}
    }
  }
`;
export const onCreatePreReservedParticipant = `
subscription onCreatePreReservedParticipant($filter:ModelSubscriptionPreReservedParticipantFilterInput) {
  onCreatePreReservedParticipant(filter: $filter) {
    ${schemas.preReservedParticipantSchema}
  }
}
`;
export const onDeletePreReservedParticipant = `
subscription onDeletePreReservedParticipant($filter:ModelSubscriptionPreReservedParticipantFilterInput) {
  onDeletePreReservedParticipant(filter: $filter) {
    ${schemas.preReservedParticipantSchema}
  }
}
`;
export const onRemovePreReservations = `
subscription onRemovePreReservations {
  onRemovePreReservations{
    ${schemas.mutationResult}
  }
}
`;
export const onUpdatePreReservedParticipant = `
subscription onUpdatePreReservedParticipant($filter:ModelSubscriptionPreReservedParticipantFilterInput) {
  onUpdatePreReservedParticipant(filter: $filter) {
    ${schemas.preReservedParticipantSchema}
  }
}
`;

export const onHandleUpdateReplicaSessions = `
subscription onHandleUpdateReplicaSessions($filter: updateReplicaFilter) {
  onHandleUpdateReplicaSessions(filter: $filter) {
    create{
      ${schemas.sessionSchema}
    }
    edit{
      ${schemas.sessionSchema}
    }
    delete{
      ${schemas.sessionSchema}
    }
    workspace
  }
}
`;

export const onHandlePreReservations = `
subscription onHandlePreReservations {
  onHandlePreReservations {
    success
    message
    data
  }
}
`;

export const onHandleCreateEditSession = `
subscription onHandleCreateEditSession($filter: SessionFilterInput) {
  onHandleCreateEditSession(filter: $filter) {
    ${schemas.sessionSchema}
  }
}
`;

export const onDeleteParticipantFromSession = `
subscription onDeleteParticipantFromSession($filter: SessionFilterInput) {
  onDeleteParticipantFromSession(filter: $filter) {
    ${schemas.sessionSchema}
  }
}
`;

export const onAddParticipantToSession = `
subscription onAddParticipantToSession($filter: SessionFilterInput) {
  onAddParticipantToSession(filter: $filter) {
    ${schemas.sessionSchema}
  }
}
`;
